module.exports = __webpack_public_path__ + "control.62d0225.png";